import { render, staticRenderFns } from "./order_check_detail.vue?vue&type=template&id=621e45f0&scoped=true"
import script from "./order_check_detail.vue?vue&type=script&lang=js"
export * from "./order_check_detail.vue?vue&type=script&lang=js"
import style0 from "./order_check_detail.vue?vue&type=style&index=0&id=621e45f0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621e45f0",
  null
  
)

export default component.exports